<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
@for (file of files; let i = $index; track $index) {
  <div
    class="file-item"
    [ngClass]="{ 'large-preview': showLargePreview && isImage(file) }"
  >
    <!-- ------------------------------- Preview ------------------------------- -->
    <div
      class="file-preview"
      [ngClass]="{ 'large-preview-image': showLargePreview && isImage(file) }"
    >
      <!-- Handle both new files and existing files with URLs -->
      @if (file.previewUrl && isImage(file)) {
        <!-- For existing files with preview URLs -->
        <img
          class="preview-image"
          [src]="file.previewUrl"
          [attr.alt]="getFileName(file)"
        />
      } @else {
        <!-- For new files or non-image files -->
        <lib-shared-preview-file
          [file]="getFileForPreview(file)"
          [contentType]="getFileContentType(file)"
          [fileUrl]="file.previewUrl"
          [usePreview]="showPreview && (isImage(file) || isVideo(file))"
        />
      }
    </div>

    <!-- ------------------------------ File info ------------------------------ -->
    <div class="file-info">
      <div class="file-name" [title]="getFileName(file)">{{
        getFileName(file)
      }}</div>
      <div class="file-details">
        @if (file.file && file.file.size) {
          <p>
            <span class="file-extension">{{ getFileExtension(file) }}</span>
          </p>
          <span class="file-size">{{ formatFileSize(file.file.size) }}</span>
          @if (file.imageRatio === '4:5') {
            <span class="file-size image-ratio-warning"> 4:5 </span>
          }
        }
      </div>

      <div *ngIf="file.progress < 100" class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="file.progress"></div>
        </div>
      </div>
    </div>

    <!-- --------------------------- Delete button ---------------------------- -->
    @if (!readOnly) {
      <button type="button" class="delete-btn" (click)="removeFile(i)">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
          />
        </svg>
      </button>
    }
  </div>
}
